const OBTENER_COLEGIOS_ESCUELAS_VACACIONES =
  "extragestor/escuelas/OBTENER_COLEGIOS_ESCUELAS_VACACIONES";

const LIMPIAR_COLEGIOS_ESCUELAS_VACACIONES =
  "extragestor/escuelas/LIMPIAR_COLEGIOS_ESCUELAS_VACACIONES";

const ELIMINAR_COLEGIO_LISTA_ESCUELAS_VACACIONES =
  "extragestor/escuelas/ELIMINAR_COLEGIO_LISTA_ESCUELAS_VACACIONES";

const ESCUELAS_SIN_COMEDOR = "extragestor/escuelas/ESCUELAS_SIN_COMEDOR";

const LIMPIAR_ESCUELAS_SIN_COMEDOR =
  "extragestor/escuelas/LIMPIAR_ESCUELAS_SIN_COMEDOR";

const ESCUELAS_CON_COMEDOR = "extragestor/escuelas/ESCUELAS_CON_COMEDOR";

const LIMPIAR_ESCUELAS_CON_COMEDOR =
  "extragestor/escuelas/LIMPIAR_ESCUELAS_CON_COMEDOR";

/*---*/
export {
  OBTENER_COLEGIOS_ESCUELAS_VACACIONES,
  LIMPIAR_COLEGIOS_ESCUELAS_VACACIONES,
  ELIMINAR_COLEGIO_LISTA_ESCUELAS_VACACIONES,
  ESCUELAS_SIN_COMEDOR,
  LIMPIAR_ESCUELAS_SIN_COMEDOR,
  ESCUELAS_CON_COMEDOR,
  LIMPIAR_ESCUELAS_CON_COMEDOR
};



// WEBPACK FOOTER //
// ./src/ducks/escuelas/types.js